import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { install as dvReferenceLineExtensionInstall } from './dvReferenceLine';
import { install as dvItemDirectionLineExtensionInstall } from './dvItemDirectionLine';

export function install(registers: EChartsExtensionInstallRegisters) {
  dvReferenceLineExtensionInstall(registers);
  dvItemDirectionLineExtensionInstall(registers);
}
